import { render, staticRenderFns } from "./mainCailiaotongzhidan.vue?vue&type=template&id=d06fac40&scoped=true&"
import script from "./mainCailiaotongzhidan.vue?vue&type=script&lang=js&"
export * from "./mainCailiaotongzhidan.vue?vue&type=script&lang=js&"
import style0 from "./mainCailiaotongzhidan.vue?vue&type=style&index=0&id=d06fac40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06fac40",
  null
  
)

export default component.exports